import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { PasswordChanged } from "@unisearch/auth/password_changed";

const Check = () => {
  return (
    <LayoutMain
      title="Password Changed"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/password-changed`}
    >
      <PasswordChanged />
    </LayoutMain>
  );
};

export default Check;
